<template>
  <v-list-group active-class="primary white--text" v-model="isOpen">
    <template v-slot:activator>
      <v-list-item-icon class="pl-1 mr-4">
        <img v-if="!isOpen" :src="FinanceOff" />
        <img v-else :src="FinanceOn" />
      </v-list-item-icon>
      <v-list-item-title>Tài chính</v-list-item-title>
    </template>
    <v-list class="py-0">
      <v-list-item
        v-if="$auth.policies['view-period-list']"
        class="px-0"
        active-class="blue lighten-4 primary--text"
        link
        to="/tuition-fee-period"
      >
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Kỳ thu/đóng</v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="$auth.policies['view-tuition-fee-group-list']"
        class="px-0"
        active-class="blue lighten-4 primary--text"
        link
        to="/tuition-fee-group"
      >
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Nhóm chịu phí</v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="$auth.policies['view-priority-group-list']"
        active-class="blue lighten-4 primary--text"
        class="px-0"
        link
        to="/tuition-fee-priority-group"
      >
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Nhóm giảm trừ</v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="$auth.policies['view-head-fee-list']"
        class="px-0"
        active-class="blue lighten-4 primary--text"
        link
        to="/head-fees"
      >
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Khoản phí thu/đóng</v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="$auth.policies['view-dedution-list']"
        active-class="blue lighten-4 primary--text"
        class="px-0"
        link
        to="/deduction-head-fees"
      >
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Khoản giảm trừ</v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="$auth.policies['view-arrear-fee-list']"
        active-class="blue lighten-4 primary--text"
        class="px-0"
        link
        to="/arrear-fees"
      >
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Khoản truy thu</v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="$auth.policies['view-refund-fee-list']"
        active-class="blue lighten-4 primary--text"
        class="px-0"
        link
        to="/refund-fees"
      >
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Khoản hoàn trả</v-list-item-title>
      </v-list-item>
      <!-- ??? Quyền xem tài khoản ngân hàng và quyền xem báo cáo theo kỳ là 1 quyền ? -->
      <v-list-item
        v-if="$auth.policies['view-bank-account-list']"
        class="px-0"
        active-class="blue lighten-4 primary--text"
        link
        to="/tuition-fee-bank-account"
      >
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Tài khoản ngân hàng</v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="$auth.policies['view-bank-account-list']"
        class="px-0"
        active-class="blue lighten-4 primary--text"
        link
        to="/financial-report"
      >
        <v-list-item-action></v-list-item-action>
        <v-list-item-title>Báo cáo theo kỳ</v-list-item-title>
      </v-list-item>
      <v-list class="py-0">
        <v-list-item
          v-if="$auth.policies['view-student-ticket']"
          active-class="blue lighten-4 primary--text"
          class="px-0"
          link
          to="/student-tickets"
        >
          <v-list-item-action></v-list-item-action>
          <v-list-item-title>Thắc mắc PHHS</v-list-item-title>
        </v-list-item>
      </v-list>
      <v-divider class="ml-8" />
      <template v-if="user.username === 'quangld' || user.username === 'nhungnh' || user.username === 'quynhdv'">
        <template v-for="(item, index) in salaryMenus">
          <v-list-item
            v-if="item.policy"
            :key="`salary_${index}`"
            class="px-0"
            active-class="blue lighten-4 primary--text"
            link
            :to="item.link"
          >
            <v-list-item-action></v-list-item-action>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </template>
      </template>
    </v-list>
  </v-list-group>
</template>

<script>
import FinanceOff from '@/assets/finance-off.svg'
import FinanceOn from '@/assets/finance-on.svg'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('auth', ['user'])
  },
  data() {
    return {
      FinanceOff,
      FinanceOn,
      isOpen: false,
      salaryMenus: [
        { link: '/salary-period', title: 'Kỳ lương', policy: 'view-salary-period' },
        { link: '/salary-group', title: 'Nhóm lương', policy: 'view-salary-group' },
        { link: '/salary-head/main', title: 'Thành phần lương', policy: 'view-salary-head-main' },
        { link: '/salary-head/adjust', title: 'Điều chỉnh lương', policy: 'view-salary-head-adjust' },
        { link: '/salary-head/sub-minus', title: 'Khoản truy thu', policy: 'view-salary-head-sub-sum' },
        { link: '/salary-head/sub-sum', title: 'Khoản hoàn trả', policy: 'view-salary-head-sub-minus' }
      ]
    }
  }
}
</script>

<style scoped></style>
